import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

const EditLabelClaimDialog = ({
  open,
  onClose,
  labelClaim,
  setLabelClaim,
  handleUpdateLabelClaim,
  handleFileChange,
}) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setLabelClaim({
      ...labelClaim,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Edit Label Claim</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          name="grade"
          label="Grade"
          type="text"
          fullWidth
          value={labelClaim.grade || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="label_claim"
          label="Label Claim"
          type="text"
          fullWidth
          required
          value={labelClaim.label_claim || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="condition"
          label="Condition"
          type="text"
          fullWidth
          required
          value={labelClaim.condition || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="ingredients"
          label="Ingredients"
          type="text"
          fullWidth
          value={labelClaim.ingredients || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="description"
          label="Description"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={labelClaim.description || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="health_claims"
          label="Health Claims"
          type="text"
          fullWidth
          required
          value={labelClaim.health_claims || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="dosage"
          label="Dosage"
          type="text"
          fullWidth
          value={labelClaim.dosage || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="format"
          label="Format"
          type="text"
          fullWidth
          value={labelClaim.format || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="amount"
          label="Amount"
          type="number"
          fullWidth
          value={labelClaim.amount || ""}
          onChange={handleChange}
          inputProps={{ step: "0.01" }}
        />
        <TextField
          margin="dense"
          name="booking_fee"
          label="Booking Fee"
          type="number"
          fullWidth
          value={labelClaim.booking_fee || ""}
          onChange={handleChange}
          inputProps={{ step: "0.01" }}
        />
        <input
          type="file"
          accept=".xlsx,.pdf"
          onChange={handleFileChange}
          style={{ marginTop: "16px" }}
        />
        <FormControlLabel
          control={
            <Checkbox
              name="prototype"
              checked={labelClaim.prototype || false}
              onChange={handleChange}
            />
          }
          label="Prototype"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="clinical_trials"
              checked={labelClaim.clinical_trials || false}
              onChange={handleChange}
            />
          }
          label="Clinical Trials"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="regulatory"
              checked={labelClaim.regulatory || false}
              onChange={handleChange}
            />
          }
          label="Regulatory"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleUpdateLabelClaim} color="primary">
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default EditLabelClaimDialog;